import axios from "axios";
import { useEffect, useState } from "react";

const API_KEY = process.env.REACT_APP_GIPHY_API_KEY;
const url = `https://api.giphy.com/v1/gifs/random?api_key=${API_KEY}`;

// ye function gif ko waha return krta hai jaha se iss function ko call kiya gaya hai
const useGif = (tag) => {
  const [loading, setLoading] = useState(true);
  const [gif, setGif] = useState("");

  // ye function API ko call krke data leke aata hai
  // uss data me se meme ko fetch krta hai
  // and upar wale "gif" state variable me meme ko set krr deta hai
  async function fetchData(tag) {
    setLoading(true);
    const { data } = await axios.get(tag ? `${url}&tag=${tag}` : url);
    const imageSource = data.data.images.downsized_large.url;
    setGif(imageSource);
    setLoading(false);
  }

  useEffect(() => {
    fetchData(tag);
  }, [tag]);

  return { loading, gif, fetchData };
};

export default useGif;